import React from "react";
import Image from "../../../elements/Image";
import useFetch from "../../../../hooks/useFetch";
import { getBlogList } from "../../../../services/BlogService";
import { removeTag } from "../../../../helpers";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useBanner } from "../../../../providers/BannerProviders";

const PartnerItem = ({ data }) => {
  return (
    <div className="relative z-0 space-y-5 px-6">
      <div className="h-12 max-w-32 overflow-hidden flex mx-auto">
        <Image
          src={data?.image}
          alt={data?.name}
          effect="blur"
          classes="object-contain"
        />
      </div>
      <div
        className="text-sm xls:text-lg text-center"
        dangerouslySetInnerHTML={{ __html: data?.title }}
      />
    </div>
  );
};

const OurPartners = () => {
  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.bannerType === "home");

  const {
    data: partnerData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-partners-list"],
    fetchFunction: async () => {
      const res = await getBlogList({
        type: "partner",
        sortQuery: "-createdAt",
        status: 1,
      });

      if (res?.docs?.status === 200) {
        const partnersArr = res?.docs?.data?.map((item) => ({
          ...item,
          name: removeTag(item?.title),
          image: item?.image?.url,
          description: removeTag(item?.title),
        }));
        return { ...res?.docs, data: partnersArr };
      } else {
        return { ...res, data: [] };
      }
    },
  });

  return (
    <>
      <section className="relative flex w-full pt-0 pb-0 lg:pb-16 xls:py-24">
        <div className="bg-chestnut-rose/10 py-8 md:py-20 px-8 md:px-10 w-full">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-0 md:px-4">
            <div className="space-y-8 md:space-y-16">
              <div className="space-y-8">
                <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
                  {homeBanner?.details?.partner?.title}
                </h2>
                <h3 className="text-center text-base xls:text-lg font-Gotham xls:font-medium">
                  {homeBanner?.details?.partner?.description}
                </h3>
              </div>
              {Array.isArray(partnerData?.data) &&
                partnerData?.data?.length > 0 && (
                  <div className="relative space-y-8 md:space-y-16">
                    <Swiper
                      loop={true}
                      breakpoints={{
                        320: { slidesPerView: 1, spaceBetween: 10 },
                        768: { slidesPerView: 2, spaceBetween: 16 },
                        990: { slidesPerView: 3, spaceBetween: 16 },
                        1025: { slidesPerView: 4, spaceBetween: 30 },
                      }}
                      freeMode={true}
                      navigation={{
                        nextEl: ".partner-swiper-button-next",
                        prevEl: ".partner-swiper-button-prev",
                      }}
                      autoplay={{ delay: 3000, disableOnInteraction: false }}
                      observer={true}
                      observeParents={true}
                      modules={[Navigation, Autoplay]}
                    >
                      {partnerData?.data?.map((item, index) => (
                        <SwiperSlide key={item?._id} className="!h-auto !flex">
                          <PartnerItem key={index} data={item} />
                        </SwiperSlide>
                      ))}
                      {partnerData?.data?.map((item, index) => (
                        <SwiperSlide key={item?._id} className="!h-auto !flex">
                          <PartnerItem key={index} data={item} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    <div className="relative flex items-center justify-center gap-4">
                      <div className="partner-swiper-button-prev relative w-9 h-9 bg-transparent border-2 border-chestnut-rose text-chestnut-rose shadow-lg flex items-center justify-center rounded-full cursor-pointer text-lg">
                        <i className="fa-regular fa-arrow-left"></i>
                      </div>
                      <div className="partner-swiper-button-next relative w-9 h-9 bg-transparent border-2 border-chestnut-rose text-chestnut-rose shadow-lg flex items-center justify-center rounded-full cursor-pointer text-lg">
                        <i className="fa-regular fa-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurPartners;
